module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图10-3.jpg?v=9d40dc59";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图10-3.jpg
 ** module id = 56
 ** module chunks = 1 2
 **/